<div class="responsive-container">
  <div class="submenu-wrapper">
    <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto vote-tab-container">
      <ng-container *ngFor="let ef of childTabs">
        <a class="vote-tab-buttons {{ef.class}}"
          [routerLink]="!isMobile ? '/elevations/' + ef.route : '/m/elevations/' + ef.route"
          [ngClass]="{ 'active-ic-vote-tab': ef.route === 'report' }">
          {{ ef.label }}
        </a>
      </ng-container>
    </div>
  </div>

  <div class="dashboard-container">
    <gridster [options]="options" class="gridster-container">
      <gridster-item *ngFor="let widget of widgets" [item]="widget" class="widget">
          <bpc-break-ins-leaderboard-widget  *ngIf="widget.type === WidgetTypes.juniorTeamBreakIns;" [widgetType]="widget.type" [title]="widget.title" [loaders]="widget.loaders" (showGrid)="showGrid($event)" (hideGrid)="hideGrid($event)"/>
          <bpc-notable-break-ins-widget *ngIf="widget.type === WidgetTypes.notableBreakIns;" [title]="widget.title" [loaders]="widget.loaders" />
          <bpc-firmwide-donut-chart-widget *ngIf="widget.type === WidgetTypes.elevationOutcomes;"  [title]="widget.title" [loaders]="widget.loaders" [chartType]="widget.chartType" (showGrid)="showGrid($event)" (hideGrid)="hideGrid($event)" />
          <bpc-elevations-bar-chart-widget *ngIf="widget.type === WidgetTypes.seniorTeamBreakIns;" [widgetType]="widget.type" [title]="widget.title" [loaders]="widget.loaders" (showGrid)="showGrid($event)" (hideGrid)="hideGrid($event)"/>
      </gridster-item>
    </gridster>
  </div>  
  <div class="responsive-container">
    <bpc-generic-listing #grid id="grid" [tableClass]="'elevation-table'" *ngIf="showTable" [title]="'Elevations'" [columns]="elevationsColumns" [companiesFilter]="companiesFilter" [hasPod]="false" [data]="companies" [totalCount]="totalCount" [isLoading]="isLoading" [hasFilters]="false" (onFilterChange)="onFilterChange($event)"/>
  </div>  
</div>